import { TranslationProvider } from "wonder-image";

export default class ApiClient {

    constructor(baseUrl, token) {

        this.baseUrl = baseUrl;
        this.token = token;

    }

    // Token CSRF del meta wi-csrf; vuoto se manca o se l'URL e' di un'altra origine
    static csrfToken(url) {

        if (typeof document === "undefined") { return ""; }

        if (url !== undefined) {
            try {
                if (new URL(url, location.href).origin !== location.origin) { return ""; }
            } catch {
                return "";
            }
        }

        return document.querySelector('meta[name="wi-csrf"]')?.content || "";

    }

    async request(endpoint, options = {}) {

        const url = `${this.baseUrl}${endpoint}`;
        const method = (options.method || "GET").toUpperCase();
        // Se il chiamante passa gia' X-WI-CSRF (con qualsiasi maiuscola) vince il suo
        const callerCsrf = Object.keys(options.headers || {}).some((key) => key.toLowerCase() === "x-wi-csrf");
        const csrf = (callerCsrf || method === "GET" || method === "HEAD") ? "" : ApiClient.csrfToken(url);

        // Senza token niente Authorization: le pagine usano sessione e CSRF
        const headers = {
            ...(this.token ? { "Authorization": `Bearer ${this.token}` } : {}),
            "Accept-Language": TranslationProvider.lang,
            ...(csrf ? { "X-WI-CSRF": csrf } : {}),
            ...options.headers,
        };

        // Se non è FormData, impostiamo JSON
        let body = options.body;

        if (!(body instanceof FormData) && body !== undefined) {
            headers["Content-Type"] = "application/json";
            body = JSON.stringify(body);
        }

        const response = await fetch(url, {
            ...options,
            headers,
            body
        });

        let data;
        const ct = response.headers.get("content-type") || "";

        try {
            data = await response.json();
        } catch {
            throw {
                success: false,
                status: response.status,
                response: "Errore nel parsing della risposta"
            };
        }
        
        if (!data.success) {
            throw data;
        }

        return data;

    }

    get(endpoint) {
        return this.request(endpoint, { method: "GET" });
    }

    post(endpoint, body) {
        return this.request(endpoint, { method: "POST", body });
    }

    put(endpoint, body) {
        return this.request(endpoint, { method: "PUT", body });
    }

    delete(endpoint) {
        return this.request(endpoint, { method: "DELETE" });
    }

}